import React, { useRef, useState } from "react";
import clsx from "clsx";
import classes from "./ImagePicker.module.css";
import { downloadImg } from "../../constant";

const ImagePicker = ({
  label,
  name,
  disabled = false,
  isOptional = false,
  errorText,
  labelStyle,
  onChange,
  value,
}) => {
  const imageInputRef = useRef();
  const [image, setImage] = useState(value || null);
  const [fileNameState, setFileNameState] = useState(null);
  const inputId = `${name}-input`;

  function handleClick() {
    if (!disabled) {
      imageInputRef?.current?.click();
    }
  }

  function handleImageChange(event) {
    const file = event?.target?.files[0];
    if (!file) {
      setImage(null);
      onChange?.(null);
      setFileNameState(null);
      return;
    }
    
    setFileNameState(file.name);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setImage(fileReader.result);
      onChange?.(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }

  function handleClear(e) {
    e.stopPropagation();
    setImage(null);
    setFileNameState(null);
    onChange?.(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
  }

  function handleDownload() {
    if (image) {
      const link = document.createElement('a');
      link.href = image;
      link.download = fileNameState || 'image';
      link.click();
    }
  }

  return (
    <div className={classes.group}>
      {label && (
        <label
          htmlFor={inputId}
          className={clsx(classes.labelText, {
            [classes.labelDisabled]: disabled,
          })}
          style={labelStyle}
        >
          {label}
          {!isOptional && (
            <>
              <span className={classes.required} aria-hidden="true">*</span>
              <span className={classes.srOnly}>(Required)</span>
            </>
          )}
        </label>
      )}

      <div 
        className={clsx(classes.container, {
          [classes.disabled]: disabled,
          [classes.error]: errorText
        })}
      >
        <input
          className={classes.input}
          type="file"
          id={inputId}
          accept="image/*"
          name={name}
          ref={imageInputRef}
          onChange={handleImageChange}
          disabled={disabled}
          aria-required={!isOptional}
          aria-invalid={!!errorText}
          aria-describedby={errorText ? `${name}-error` : undefined}
        />

        <div className={classes.buttonWrapper}>
          <button
            onClick={handleClick}
            className={clsx(classes.button, {
              [classes.buttonDisabled]: disabled,
            })}
            type="button"
            disabled={disabled}
            aria-label="Choose image file"
          >
            <img 
              src={downloadImg} 
              alt="Choose file" 
              className={clsx(classes.downloadImg, 'img-fluid')} 
            />
          </button>
        </div>
      </div>

      {fileNameState && (
        <div className={classes.fileInfo}>
          <button
            type="button"
            onClick={handleDownload}
            className={classes.fileName}
          >
            {fileNameState}
          </button>
          <button
            onClick={handleClear}
            className={classes.clearButton}
            type="button"
            aria-label="Clear selected file"
          >
            ✕
          </button>
        </div>
      )}

      {errorText && (
        <p 
          id={`${name}-error`} 
          className={classes.errorText}
        >
          {errorText}
        </p>
      )}
    </div>
  );
};

export default ImagePicker;